import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { LayoutService } from '../layout.service';
import { UserService } from '../../core/services/user.service';
import { PageService } from '../../core/services/page.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/core/services/data.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.css'],
    standalone: false
})
export class TopbarComponent implements OnInit {
  currentPage = 'Appointments';
  user: any;
  notificationCount = 0;
  showNotifications = false;
  showProfileMenu = false;
  selectedCountry: any;

  profileData: any;
  profileImg: string = '';
  countryCodeMap: { [key: string]: string } = {
    "Argentina": "ar",
    "Australia": "au",
    "Austria": "at",
    "Belgium": "be",
    "Bosnia": "ba",
    "Brazil": "br",
    "Bulgaria": "bg",
    "Canada": "ca",
    "Chile": "cl",
    "China": "cn",
    "Croatia": "hr",
    "Czech Republic": "cz",
    "Denmark": "dk",
    "Estonia": "ee",
    "Finland": "fi",
    "France": "fr",
    "Germany": "de",
    "Herzegovina": "ba",
    "Iceland": "is",
    "India": "in",
    "Indonesia": "id",
    "Israel": "il",
    "Italy": "it",
    "Latvia": "lv",
    "Lithuania": "lt",
    "Macedonia": "mk",
    "Malaysia": "my",
    "Mexico": "mx",
    "Moldova": "md",
    "Montenegro": "me",
    "Netherlands": "nl",
    "New Zealand": "nz",
    "Norway": "no",
    "Poland": "pl",
    "Portugal": "pt",
    "Romania": "ro",
    "Serbia": "rs",
    "Singapore": "sg",
    "Slovakia": "sk",
    "Slovenia": "si",
    "South Africa": "za",
    "South Korea": "kr",
    "Spain": "es",
    "Sweden": "se",
    "Switzerland": "ch",
    "Turkey": "tr",
    "Ukraine": "ua",
    "United Arab Emirates": "ae",
    "United Kingdom": "gb",
    "United States": "us",
    "USA": "us"
  };
  citizen: any[] = [];
  country: any;
  flagName: any;
  fullName: string = '';

  constructor(
    private userService: UserService,
    private dataService: DataService,
    private authService: AuthService,
    public router: Router,
    private pageService: PageService,
    private route: ActivatedRoute,
    private elementRef: ElementRef,
    private layoutService: LayoutService
  ) { }

  toggleSidebar() {
    this.layoutService.toggleSidebar();
  }

  // Close the profile detail card when clicking anywhere outside it
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.showProfileMenu && !this.elementRef.nativeElement.contains(event.target)) {
      this.showProfileMenu = false;
    }
  }

  ngOnInit() {
    if (localStorage.getItem('TOKEN')) {
    this.dataService.profilePic$.subscribe(url => {
      this.profileImg = url;
    });
    this.getProfile();

    // this.userService.fullName$.subscribe(name => {
    //   this.getProfile();
    // });
  }

    this.authService.unreadCount$.subscribe(() => {
    });

    this.userService.getCurrentUser().subscribe(user => {
      this.user = user;
      this.selectedCountry = {
        code: user.countryCode,
        name: user.countryName,
        flag: user.countryFlag
      };
    });

    const initialSegments = window.location.pathname.split('/').filter(Boolean);
    const urlSegment = (initialSegments[0] === 'consumer' ? initialSegments[1] : initialSegments[0]) || '';
    const pageMap: { [key: string]: string } = {
      audittrails: 'Audit Trails',
      notifications: 'Notifications',
      dashboard: 'Dashboard',
      health: 'Health',
      documents: 'Documents',
      chats: 'Chats',
      settings: 'Profile Info',
      calendar: 'Appointments',
      appointments: 'Appointments',
      connections: 'Connections',
      subscription: 'Payments',
      bookslot: 'Appointments',
      appointmenthistory: 'Appointments'
    };
    const resolvedPage = pageMap[urlSegment] || (urlSegment.charAt(0).toUpperCase() + urlSegment.slice(1));
    this.currentPage = resolvedPage;
    this.pageService.setCurrentPage(resolvedPage);
    localStorage.setItem('navItem', resolvedPage);

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event) => {
        const navEndEvent = event as NavigationEnd;
        const urlWithoutParams = navEndEvent.urlAfterRedirects.split('?')[0];
        const segments = urlWithoutParams.split('/').filter(Boolean);
        const urlSegment = (segments[0] === 'consumer' ? segments[1] : segments[0]) || '';

        const allowedPages = [
          'dashboard', 'health', 'documents', 'chats', 'settings',
          'audittrails', 'notifications', 'calendar', 'connections',
          'appointments', 'subscription', 'bookslot'
        ];

        if (allowedPages.includes(urlSegment)) {
          const pageMap: { [key: string]: string } = {
            audittrails: 'Audit Trails',
            notifications: 'Notifications',
            dashboard: 'Dashboard',
            health: 'Health',
            documents: 'Documents',
            chats: 'Chats',
            settings: 'Profile Info',
            calendar: 'Appointments',
            appointments: 'Appointments',
            connections: 'Connections',
            subscription: 'Payments',
            bookslot: 'Appointments',
            appointmenthistory: 'Appointments'
          };

          this.currentPage = pageMap[urlSegment] ||
            (urlSegment.charAt(0).toUpperCase() + urlSegment.slice(1));

          this.pageService.setCurrentPage(this.currentPage);
          localStorage.setItem('navItem', this.currentPage);
        }
      });

    this.pageService.currentPage$.subscribe(page => {});

    //this.getProfile();
  }

  getProfile() {
    this.authService.get_digicoffer_profile().subscribe((user: any) => {
      this.profileData = user.data.profile;
      this.fullName = `${this.profileData.first_name} ${this.profileData.last_name}`;
    });
    this.authService.get_image().subscribe((img: any) => {
      this.profileImg = img.data.imageUrl;
      localStorage.setItem('profileImg', this.profileImg);
    });
  }

  getCitizenships() {
    this.authService.get_citizenship().subscribe((res: any) => {
      this.citizen = res.data?.citizenships || [];
      const primary = this.citizen.find((item: any) => item.index === 'citizen_primary');
      if (primary) {
        this.selectedCountry = primary;
        localStorage.setItem('primaryCountry', primary.countryName);
      }
    });
  }

  getCountries() {
    this.authService.getCountries().subscribe((res: any) => {
      this.country = res.data.country;
    });
  }

  getCountryCode(countryName: string): string {
    const name = countryName.trim();
    const code = this.countryCodeMap[name];
    if (!code) {
      console.warn(`Missing country code for: ${name}`);
    }
    return code || '';
  }

  getFlagUrl(countryName: string): string {
    this.flagName = countryName;
    localStorage.setItem('citizenship', this.flagName);
    const code = this.getCountryCode(countryName).toLowerCase();
    return code ? `https://flagcdn.com/${code}.svg` : '';
  }

  toggleNotifications() {
    this.showNotifications = !this.showNotifications;
    this.showProfileMenu = false;
    this.router.navigate(['/consumer/notifications']);
  }

  toggleProfileMenu() {
    this.showProfileMenu = !this.showProfileMenu;
    this.showNotifications = false;
  }

  getNotification() {
    this.authService.get_notifications().subscribe((res: any) => {
      if (!res.error && res.data?.notifications?.length) {
        const allNotifications = res.data.notifications;
        this.notificationCount = allNotifications.filter(
          (notif: any) => notif.status === 'unread'
        ).length;
      } else {
        this.notificationCount = 0;
      }
    });
  }

  gotoVideoConsult() {
    this.router.navigate(['/consumer/videoconsult']);
  }

  gotoLegalVerification() {
    this.router.navigate(['/consumer/legal-verification']);
  }
}